import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'sales-analytics',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const SalesAnalytics = require('./containers/SalesAnalyticsContainer').default
      const {loadStoreOptionsReducer, loadStoreTagOptionsReducer, loadBrandNamesReducer, totalSalesReducer, productSalesSplitReducer} = require('./modules/salesAnalytics')

      injectReducer(store, {key: 'productSalesSplit', reducer: productSalesSplitReducer})
      injectReducer(store, {key: 'totalSales', reducer: totalSalesReducer})
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'storeTagOptions', reducer: loadStoreTagOptionsReducer})
      injectReducer(store, {key: 'brands', reducer: loadBrandNamesReducer})

      /*  Return getComponent   */
      callback(null, SalesAnalytics)

      /* Webpack named bundle   */
    }, 'SalesAnalyticsView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/SalesAnalytics/index.js